import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import "./AddRessourceModal.css";

const AddRessourceModal = ({ show, onClose, onCreated, showToast }) => {
  const [form, setForm] = useState({
    name: "",
    type: "Logiciel",
    exposition: 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "exposition" ? parseFloat(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("/api/add_ressource.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (data.success) {
        showToast("Ressource ajoutée !");
        onCreated?.();
        onClose();
      } else {
        showToast(data.error || "Erreur lors de l'ajout", "danger");
      }
    } catch (err) {
      console.error("Erreur ajout ressource:", err);
      showToast("Erreur réseau", "danger");
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="add-ressource-modal"
    >
      <Form onSubmit={handleSubmit}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-box-seam me-2 text-warning" />
              Ajouter une Ressource
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {/* 🔹 Nom */}
            <div className="mb-3">
              <Form.Label>Nom</Form.Label>
              <Form.Control
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                placeholder="Ex: Serveur Agence"
              />
            </div>

            {/* 🔹 Type */}
            <div className="mb-3">
              <Form.Label>Type</Form.Label>
              <Form.Select name="type" value={form.type} onChange={handleChange}>
                <option value="Logiciel">Logiciel</option>
                <option value="Matériel">Matériel</option>
                <option value="Informationnel">Informationnel</option>
                <option value="Humain">Humain</option>
                <option value="Externe">Externe</option>
              </Form.Select>
            </div>

            {/* 🔹 Exposition */}
            <div className="mb-3">
              <Form.Label>Exposition (1 à 4)</Form.Label>
              <Form.Control
                type="number"
                name="exposition"
                min="1"
                max="4"
                step="0.1"
                value={form.exposition}
                onChange={handleChange}
              />
              <small className="text-secondary">
                Évaluez l’exposition de cette ressource (ex: exposée à Internet, critique, etc.)
              </small>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-profile" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-profile btn-success">
              Ajouter
            </button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default AddRessourceModal;
